"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var InlineMessageComponentStyle_1 = require("./InlineMessageComponentStyle");
var InlineMsgComponent = function (props) {
    return (React.createElement(InlineMessageComponentStyle_1.InlineErrorContainer, null,
        React.createElement("span", { className: "exclamation" },
            React.createElement("svg", { "aria-hidden": "true", focusable: "false", width: "15px", height: "16px", viewBox: "0 0 24 24", fill: "#e51c23" },
                React.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" }),
                React.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }))),
        React.createElement(InlineMessageComponentStyle_1.MessageComponentSpan, null, props.inlineMsg)));
};
exports.default = InlineMsgComponent;
//# sourceMappingURL=InlineMessageComponent.js.map